"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconUploadPlaceholder = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M13.21 47.25a8.71 8.71 0 0 1-4.75-1.55 1.6 1.6 0 0 0-1.82 2.63 11.91 11.91 0 0 0 6.49 2.13 1.6 1.6 0 0 0 0-3.2zM7.51 31.56a1.59 1.59 0 0 0 .92-.29 8.72 8.72 0 0 1 4.75-1.57 1.6 1.6 0 1 0-.1-3.2 11.91 11.91 0 0 0-6.48 2.15 1.6 1.6 0 0 0 .92 2.91zM37 14.88a15 15 0 0 1 5 1.91 1.6 1.6 0 1 0 1.65-2.74 18.15 18.15 0 0 0-6.12-2.32 1.6 1.6 0 0 0-.53 3.15zM57.94 25.47a11.37 11.37 0 0 1 4.34 2.88 1.6 1.6 0 0 0 2.34-2.19A14.59 14.59 0 0 0 59 22.47a1.6 1.6 0 1 0-1.11 3zM24.85 17.5a1.6 1.6 0 0 0 .9-.28A15 15 0 0 1 30.68 15a1.6 1.6 0 0 0-.74-3.11 18.18 18.18 0 0 0-6 2.64 1.6 1.6 0 0 0 .9 2.92zM19.39 26.76a15 15 0 0 1 2-5A1.6 1.6 0 1 0 18.67 20a18.14 18.14 0 0 0-2.42 6.08A1.6 1.6 0 0 0 17.5 28a1.62 1.62 0 0 0 .32 0 1.6 1.6 0 0 0 1.57-1.24zM4.67 38.47A8.79 8.79 0 0 1 5 36a1.6 1.6 0 1 0-3-.92 12 12 0 0 0-.49 3.38A11.88 11.88 0 0 0 2 41.91 1.6 1.6 0 1 0 5 41a8.78 8.78 0 0 1-.33-2.53zM26.16 47.25h-6a1.6 1.6 0 0 0 0 3.2h6a1.6 1.6 0 0 0 0-3.2zM51.3 21.84l-.52.11a18.37 18.37 0 0 0-1.56-2.7 1.6 1.6 0 1 0-2.62 1.83 15.13 15.13 0 0 1 1.77 3.35 1.6 1.6 0 0 0 2 1A11.08 11.08 0 0 1 51.9 25a1.6 1.6 0 1 0-.6-3.14zM68.21 33.05a1.6 1.6 0 1 0-3.13.67 11.45 11.45 0 0 1 .25 2.37 11.31 11.31 0 0 1-.33 2.84 1.6 1.6 0 1 0 3.1.8 14.63 14.63 0 0 0 .14-6.68zM61.93 44.16a11.35 11.35 0 0 1-4.46 2.69 1.6 1.6 0 1 0 1 3 14.56 14.56 0 0 0 5.72-3.45 1.6 1.6 0 0 0-2.24-2.29zM51 47.39h-6a1.6 1.6 0 0 0 0 3.2h6a1.6 1.6 0 0 0 0-3.2z"
  }), _react["default"].createElement("path", {
    d: "M44.13 42.09a1.6 1.6 0 1 0 2.26-2.26L35.7 29.14a1.65 1.65 0 0 0-2.26 0l-10.7 10.69A1.6 1.6 0 0 0 25 42.09l8-8V57a1.6 1.6 0 1 0 3.2 0V34.13z"
  })),
  height: undefined,
  width: undefined
});
IconUploadPlaceholder.displayName = 'IconUploadPlaceholder';
var _default = IconUploadPlaceholder;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/upload-placeholder.js
// module id = 602
// module chunks = 0